import { unwrap, IDBPDatabase, IDBPTransaction } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema, IMigration } from '../types'

import to1 from './to-1'
import to2 from './to-2'
import to3 from './to-3'
import to4 from './to-4'
import to5 from './to-5'
import to6 from './to-6'
import to7 from './to-7'
import to8 from './to-8'
import to9 from './to-9'
import to10 from './to-10'
import to11 from './to-11'
import to12 from './to-12'
import to13 from './to-13'

const migrations: IMigration[] = [
  to1,
  to2,
  to3,
  to4,
  to5,
  to6,
  to7,
  to8,
  to9,
  to10,
  to11,
  to12,
  to13,
]

const migrate = (
  database: IDBPDatabase<IDBSchema>,
  oldVersion: number,
  newVersion: number,
  decoratedTransaction: IDBPTransaction<IDBSchema>
) => {
  console.log('------Starting IndexedDB migration------')

  const nativeTransaction = unwrap(decoratedTransaction)

  asyncForEach(
    migrations.slice(oldVersion), // Start migrating from the old version. If you are multiple versions behind, all migrations FROM that version will be applied
    (migration, next) => migration(database, nativeTransaction, next),
    () => console.log('------IndexedDB migration complete------')
  )
}

export default migrate
